<template>
  <div class="layout-container">
    <Header 
      :is-mobile="isMobile"
      :unread-count="unreadCount"
      @toggle-sidebar="toggleSidebar"
    />
    
    <div class="layout-body">
      <Sidebar
        v-show="!isMobile || sidebarVisible"
        :class="{ 'mobile-visible': isMobile && sidebarVisible }"
        :collapsed="sidebarCollapsed && !isMobile"
        :title="sidebarTitle"
        @toggle-collapse="toggleSidebarCollapse"
      />
      
      <div class="layout-content">
        <div class="page-container">
          <!-- 页面头部 -->
          <div v-if="$slots.header || pageTitle" class="page-header">
            <h2 v-if="pageTitle" class="page-title">{{ pageTitle }}</h2>
            <div class="page-actions">
              <slot name="header"></slot>
            </div>
          </div>
          
          <!-- 页面内容 -->
          <div class="page-content">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 移动端遮罩层 -->
    <div
      v-if="isMobile && sidebarVisible"
      class="mobile-overlay"
      @click="sidebarVisible = false"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import Header from './Header.vue'
import Sidebar from './Sidebar.vue'

interface Props {
  pageTitle?: string
}

defineProps<Props>()

const authStore = useAuthStore()
const { userType } = storeToRefs(authStore)

// 响应式状态
const isMobile = ref(false)
const sidebarVisible = ref(false)
const sidebarCollapsed = ref(false)
const unreadCount = ref(0)

// 计算属性
const sidebarTitle = computed(() => {
  if (userType.value === 1) {
    return '平台管理员'
  }
  if (userType.value === 2) {
    return '组织管理员'
  }
  if (userType.value === 3) {
    return '分支组织管理员'
  }
  if (userType.value === 4) {
    return '分支组织员工'
  }
  return '导航'
})

// 方法
const toggleSidebar = () => {
  sidebarVisible.value = !sidebarVisible.value
}

const toggleSidebarCollapse = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value
}

const handleResize = () => {
  const width = window.innerWidth
  isMobile.value = width < 768
  
  if (!isMobile.value) {
    sidebarVisible.value = false
  }
}

// 生命周期
onMounted(() => {
  handleResize()
  window.addEventListener('resize', handleResize)
  
  // 加载未读通知数量
  loadUnreadCount()
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

const loadUnreadCount = async () => {
  try {
    // TODO: 调用API获取未读通知数量
    // const response = await notificationApi.getUnreadCount()
    // unreadCount.value = response.data.count
  } catch (error) {
    console.error('Failed to load unread count:', error)
  }
}
</script>

<style lang="less" scoped>
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 99;
}

@media (max-width: 768px) {
  .layout-sidebar {
    &:global(.mobile-visible) {
      transform: translateX(0);
    }
  }
}
</style>
